import api from '../services/api';

/**
 * Shop API client
 */
export const shopAPI = {
  /**
   * Get shop items
   * @param {Object} params - Query parameters (item_type, is_active, etc.)
   */
  getItems: async (params = {}) => {
    try {
      const response = await api.get('shop/items/', { params });
      return response.data;
    } catch (error) {
      if (error.response?.data?.message === 'HANDLED_LIMIT') {
        return [];
      }
      throw error;
    }
  },

  /**
   * Get single shop item by ID
   * @param {number} itemId - Shop item ID
   */
  getItem: async (itemId) => {
    const response = await api.get(`shop/items/${itemId}/`);
    return response.data;
  },

  /**
   * Purchase a shop item
   * @param {number} shopItemId - Shop item ID to purchase
   */
  purchaseItem: async (shopItemId) => {
    const response = await api.post('shop/purchase/', { shop_item_id: shopItemId });
    const data = response.data;

    // Ensure is_consumable is set correctly
    if (data.shop_item) {
      const itemType = data.shop_item.item_type;
      if (!data.hasOwnProperty('is_consumable')) {
        data.is_consumable = itemType === 'BOOSTER' || itemType === 'PROTECTOR';
      }
    }
    return data;
  },

  /**
   * Get student's inventory
   * @param {Object} params - Query parameters (is_equipped, shop_item__item_type, etc.)
   */
  getInventory: async (params = {}) => {
    const response = await api.get('users/inventory/', { params });
    return response.data;
  },

  /**
   * Equip or unequip an inventory item
   * @param {number} inventoryItemId - Inventory item ID
   */
  equipItem: async (inventoryItemId) => {
    const response = await api.post(`users/inventory/${inventoryItemId}/equip/`);
    return response.data;
  },
};
